import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { ApiOutlined } from '@ant-design/icons';
import { RequestTrackingStatisticsResponse } from '@openapi';
import { formatNumber, formatTime } from '../utils/trackingUtils';

interface ApiVersionDetailsProps {
  statistics: RequestTrackingStatisticsResponse;
}

const ApiVersionDetails: React.FC<ApiVersionDetailsProps> = ({ statistics }) => {
  return (
    <Card title="API Version Details" style={{ marginBottom: 24 }}>
      <Row gutter={16}>
        {statistics.versionStats?.map((version) => (
          <Col xs={24} md={12} key={version.apiVersion}>
            <Card
              type="inner"
              title={
                <span>
                  <ApiOutlined /> API {(version.apiVersion || 'unknown').toUpperCase()}
                </span>
              }
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Statistic
                    title="Total Requests"
                    value={formatNumber(version.count || 0)}
                    valueStyle={{ fontSize: 16 }}
                  />
                </Col>
                <Col span={12}>
                  <Statistic
                    title="Avg Time"
                    value={formatTime(version.avgExecutionTime || 0)}
                    valueStyle={{ fontSize: 16 }}
                  />
                </Col>
                <Col span={12}>
                  <Statistic
                    title="Success Rate"
                    value={version.successRate || '0%'}
                    valueStyle={{ color: '#52c41a', fontSize: 16 }}
                  />
                </Col>
                <Col span={12}>
                  <Statistic
                    title="Error Rate"
                    value={version.errorRate || '0%'}
                    valueStyle={{ color: '#ff4d4f', fontSize: 16 }}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default ApiVersionDetails;
